import { render, staticRenderFns } from "./ApplyResult.vue?vue&type=template&id=6a968d65&scoped=true&"
import script from "./ApplyResult.vue?vue&type=script&lang=js&"
export * from "./ApplyResult.vue?vue&type=script&lang=js&"
import style0 from "./ApplyResult.vue?vue&type=style&index=0&id=6a968d65&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a968d65",
  null
  
)

export default component.exports